@if (loading()) {
  <mat-spinner [diameter]="size() === 'small' ? 16 : 20"></mat-spinner>
} @else if (size() === 'normal') {
  <!--
    Miroir exact de vl-edit-button (vl-chips) — state error-outline dédié.

    ⚠️ **`[disabled]` était DÉCORATIF.** L'entrée existait, trois écrans la passaient — et le template ne
    l'appliquait nulle part : le clic partait quand même. Conséquences réelles : le refus de supprimer une
    unité de gestion employée ne refusait rien (`custom-enum-form`), un coût non supprimable se supprimait
    (`cost`), et le bouton restait cliquable pendant l'enregistrement d'une commande (`commande-resume`),
    donc double-clic possible sur une mutation serveur.

    ⚠️ **Aucune infobulle propre quand le geste est refusé.** Le parent en pose une qui NOMME le motif
    (« cette unité est employée par… ») ; garder « Supprimer » par-dessus affichait les deux superposées,
    et celle qui reste lisible est justement celle qui n'apprend rien.

    ⚠️ **Le garde est POSÉ AUX DEUX ENDROITS** : ici et dans `onDelete()`. Le seul attribut suffirait pour
    la souris, mais pas pour un appel programmatique du geste — et c'est précisément ce que fait un test e2e.
  -->
  <vl-chips
    data-testid="btn-delete"
    state="error-outline"
    iconLeft="delete"
    [disabled]="disabled"
    [matTooltip]="disabled ? '' : ('button.delete' | trans)"
    (action)="onDelete()"
  />
} @else if (size() === 'small') {
  <vl-chips
    data-testid="btn-delete"
    state="error-outline"
    size="small"
    iconLeft="delete"
    [disabled]="disabled"
    [matTooltip]="disabled ? '' : ('button.delete' | trans)"
    (action)="onDelete()"
  />
}
